// extracted by mini-css-extract-plugin
module.exports =  {"box":"kOkOzDW","box-hidden":"f0TxcrC","boxHidden":"f0TxcrC","with-animation":"C0SiwSF","withAnimation":"C0SiwSF","fadeIn":"BeIXD4B","content":"DuPw8a8"};